//import 'prefixfree';
import 'browsernizr/test/touchevents';
import Modernizr from 'browsernizr';
import 'browsernizr/lib/mq';
import './jquery';
import './easing';
import './texelwire';
//import './slick';
import './simple-dd';
//import './magnific';
//import './select2';
import './ideal-postcodes';
import autosize from './autosize';
import mapStyle from './map-style.json';
import './enllax';
import URLSearchParamsPolyfill from 'url-search-params-polyfill';
import './cycle2';
import './datepicker';
import twireStripe from './twire-stripe';


'use strict';


const URLSearchParamsClass = window.URLSearchParams || URLSearchParamsPolyfill;
window.urlParams = new URLSearchParamsClass(window.location.search);


/**
 * Cache
 */
var $window			= $(window);
var $document 		= $(document);
var $htmlBody 		= $('html, body');
var $body 			= $('body');
var $header 		= $('header');
var $main 			= $('main');
var $mainNavs 		= $('header, div.mobile-menu');

 
/**
 * Add spans to headings for border decoration
 */
$('div.h1, h1, h2, h3, h4, h5, h6').not('.alt').wrapInner('<span class="decor"></span>');


/**
 * Menu highlight
 */
$mainNavs.find('a[href="' + $.escapeSelector(window.location.pathname) + '"]').addClass('active');
$mainNavs.find('span.drop-down span.child a.active').each(function() {

	$(this).closest('span.drop-down')
	       .children('a')
		   .addClass('active');

});


/**
 * Mobile menu
 */
$('div.mobile-menu nav').prepend($header.find('nav.menu').html());


/**
 * Menu open
 */
$('a.menu-open').on('click', function(e) {
	
	e.preventDefault();
	
	$body.addClass('menu-open');
	
});


/**
 * Menu close
 */
$('div.mobile-menu-base, a.menu-close').on('click', function(e) {
	
	e.preventDefault();
	
	$body.removeClass('menu-open');
	
});


/**
 * Guide tabs (must be before scroll-to)
 */
$('body.guides-and-insights').each(function() {

	var $a = $('main nav.icons a');
	
	$a.on('click', function(e) {
		
		e.preventDefault();
		
		var $this = $(this);
		
		$a.closest('nav.icons')
		  .find('a')
		  .removeClass('active');
		  
		$this.addClass('active');
		
		$main.find('div.categories div.category')
		     .removeClass('active');
			  
		$main.find($this.attr('href'))
			 .addClass('active');
		
	});

});


/**
 * Scroll to
 */
$('a[data-scroll-to]').on('click', function(e) {

	e.preventDefault();
	
	var $this = $(this);

	$htmlBody.animate({

		scrollTop: $($this.attr('href')).offset().top - $header.innerHeight()

	}, 1000, 'easeInOutExpo');

})


/**
 * Go to
 */
var urlParams = new URLSearchParams(window.location.search);
var goto = urlParams.get('goto');

if (goto !== null) {
	
	$('a[data-scroll-to][href="#' + $.escapeSelector(goto) + '"]').eq(0)
	                                                              .trigger('click');
	
}


/**
 * Property links
 */
$('div.properties div.property').css('cursor', 'pointer')
                 .on('click', function() {

	window.location = $(this).data('href');

});


/**
 * Company tabs
 */
$('div.company-tabs').each(function() {

	var $this = $(this);
	
	$this.find('nav a')
	     .on('click', function(e) {
		
		e.preventDefault();
		
		var $a = $(this);
		
		$a.closest('nav')
		  .find('a')
		  .removeClass('alt');
		  
		$a.addClass('alt');
		
		$this.find('div.panel')
		     .removeClass('active')
			 .filter('div.' + $a.data('panel'))
			 .addClass('active');	 
			 
	});
	
	var tab = urlParams.get('tab');

	if (tab !== null) {
		
		$this.find('nav a[data-panel="' + $.escapeSelector(tab) + '"]').trigger('click');
		
	}

});


/**
 * Show next
 */
$('a.show-next').one('click', function(e) {
	
	e.preventDefault();
	
	$(this).addClass('active');
	
});


/**
 * Autosize
 */
autosize($('form textarea'));


/**
 * Select2
 */
const $selects = $('select');

if ($selects.length > 0) {

	await import('./select2');

	$selects.select2({

		width: '100%',
		minimumResultsForSearch: -1

	});

}


/**
 * Slick promos
 */
var $slickElements = $('div.slick-promos');

if ($slickElements.length > 0) {

	await import('./slick');

	$slickElements.slick({

		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		prevArrow: '<a class="slick-prev fa fa-angle-left"></a>',
		nextArrow: '<a class="slick-next fa fa-angle-right"></a>',
		responsive: [

			{

				breakpoint: 1170,
				settings: {

					slidesToShow: 2

				}

			},
			{

				breakpoint: 700,
				settings: {

					slidesToShow: 1

				}

			}

		]

	});

}


/**
 * Slick pager
 */
$slickElements = $('div.slick-pager');

if ($slickElements.length > 0) {

	await import('./slick');

	$slickElements.slick({

		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		prevArrow: '<a class="slick-prev fa fa-angle-left"></a>',
		nextArrow: '<a class="slick-next fa fa-angle-right"></a>',
		lazyLoad: 'progressive',
		adaptiveHeight: true
		
	});

}


/**
 * Property links and radios
 */
$('body.property').each(function() {
	
	var $propertyform = $('div#property-enquiry form');

	$('a[data-enquiry-type]').on('click', function(e) {
		
		e.preventDefault();
		
		$propertyform.find('input[name="enquiry-type"][value="' + $(this).data('enquiry-type') + '"]')
		             .prop('checked', true)
					 .trigger('change');
					 
	});
	
	$('div#property-enquiry form input[name="enquiry-type"]').on('change', function() {
		
		var text = $propertyform.find('input[name="enquiry-type"]:checked').val() + ' for ' + $propertyform.find('h2').data('property-name');
		
		$propertyform.find('h2')
		             .text(text);
					 
		$propertyform.find('input[name="property"]')
			 		 .val(text);
		
	});

});


/**
 * Magnific
 */
const $lightboxes = $('a.lightbox.video, a.lightbox.iframe, a.lightbox.inline, div.lightbox.gallery');

if ($lightboxes.length > 0) {
	
	try {

		await import('./magnific');

		// Video Lightbox
		$('a.lightbox.video').magnificPopup({

			disableOn: 900,
			type: 'iframe',
			mainClass: 'lightbox-effect',

		});

		$('a.lightbox.iframe').magnificPopup({
			
			type: 'iframe',
			mainClass: 'mfp-fade'
			
		});

		// Inline Lightbox
		$('a.lightbox.inline').magnificPopup({

			type: 'inline',
			mainClass: 'lightbox-effect',

		});

		// Gallery
		$('div.lightbox.gallery').magnificPopup({

			delegate: 'a',
			type: 'image',
			mainClass: 'lightbox-effect',
			gallery: {

				enabled: true,
				navigateByImgClick: true,
				preload: [0, 1]

			}

		});

	} catch (err) {

		console.error("Magnific Popup failed to load:", err);

	}

}


/**
 * Simple DD
 */
$header.find('span.drop-down')
       .simpleDD({

   noScriptLink:    '> a',
   dropdownElement: 'span.child'

});


/**
 * Alt header
 */
$window.on('scroll resize', function() {

    if ($window.scrollTop() > 100) {

        $header.addClass('alt');

    } else {

        $header.removeClass('alt');

    }

});


/**
 * Ideal postcodes
 */
var $requestValuation = $('body.request-valuation, body.general-page');

$requestValuation.find('form.pseudo-form').each(function() {
	
	var $form = $(this);
	
	new IdealPostcodes.Autocomplete.Controller({

		api_key: 'ak_kh09fya71OwMw63mFv6tPDS0O99Ja',
		inputField: 'form#request-valuation input[name="search"]',
		outputFields: {

			post_town: 		'form#request-valuation input[name="city"]',
			postal_county: 	'form#request-valuation input[name="county"]',
			postcode: 		'form#request-valuation input[name="postcode"]'

		},
		checkKey: true,
	    onFailedCheck: function () {

	        $form.find('input[name="search"]').closest('div.row')
			                                  .remove();
											  
			$form.addClass('manual');

	    },
		onSearchError: function(response) {

			alert('An address search error occured; please enter your address manually');

			$form.find('input[name="search"]').closest('div.row')
			                                  .remove();
											  
			$form.addClass('manual');

		},
		onAddressRetrieved: function(address) {

			var street = address.line_1;

			street += address.line_2 !== '' ? ', ' + address.line_2 : '';
			street += address.line_3 !== '' ? ', ' + address.line_3 : '';

			$form.find('input[name="street"]').val(street);

			$form.find('input[name="search"]').val('');
			
			$form.addClass('manual');
			
			// Remove manual link
			$form.find('a.manual')
			     .closest('div.row')
				 .remove();

		}

	});

});


/**
 * Request valuation manual link
 */
$requestValuation.find('form a.manual')
                 .on('click', function(e) {
					 
	e.preventDefault();
	
	var $this = $(this);
	
	$this.closest('form')
	     .addClass('manual');
		 
	$this.closest('div.row')
	     .remove();				 
					 
});


/**
 * Testimonials option
 */
$('div.testimonials.home div.options a').on('click', function(e) {
	
	e.preventDefault();
	
	var $this	= $(this);
	
	var $panels = $this.closest('div.testimonials').find('div.quotes div.panel');
	var $links 	= $this.closest('div.options').find('a');
	
	$panels.removeClass('active');
	$links.removeClass('active');
	
	$panels.eq($this.index())
	      .addClass('active');
		  
	$this.addClass('active');
	
}).eq(0)
  .trigger('click');
  


/**
 * Locrating
 */
$('div.locrating').each(function() {

	try {

		setLocratingIFrameProperties($(this).data('config'));

	} catch (err) {

		console.log('Locrating error:');
		console.log(err);

	};

});


/**
 * Map
 */
$('div.map:not(.single)').each(function() {
	
	var $map = $(this);
	
	var coordinates = $map.data('coordinates');
	
	var location = new google.maps.LatLng(coordinates[0].latitude, coordinates[0].longitude);
	
	var markers = [];

	var map = new google.maps.Map($map[0], {

		center: location,
		zoom: 12,
		scrollwheel: false,
		styles: mapStyle,
		zoomControl: true

	});
	
	for (var counter = 0; counter < coordinates.length; counter ++) {
		
		location = new google.maps.LatLng(coordinates[counter].latitude, coordinates[counter].longitude);
		
		var marker = new google.maps.Marker({

			map: map,
			position: location,
			icon: {

				url: '/assets/img/gui/marker.png',
				scaledSize: new google.maps.Size(50, 50)

			},
			url: coordinates[counter].url

		});
		
		markers.push(marker);
		
	}
	
	// Add click handlers
	for (var counter = 0; counter < markers.length; counter ++) {

		google.maps.event.addListener(markers[counter], 'click', function() {

			window.location.href = this.url;

		});
		
	}
	
	// Fit bounds
	var bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i ++) {
		
        if (markers[i].getVisible()) {
			
            bounds.extend( markers[i].getPosition());
			
        }
		
    }

    map.fitBounds(bounds);

});


/**
 * Map single
 */
$('div.map.single').each(function() {
	
	var $map = $(this);
	
	var latitude  = $map.data('latitude');
	var longitude = $map.data('longitude');
	
	var location = new google.maps.LatLng(latitude, longitude);

	var map = new google.maps.Map($map[0], {

		center: location,
		zoom: 12,
		scrollwheel: false,
		styles: mapStyle,
		zoomControl: true

	});

	new google.maps.Marker({

		map: map,
		position: location,
		icon: {

			url: '/assets/img/gui/marker.png',
			scaledSize: new google.maps.Size(50, 50)

		}

	});

});


/**
 * Window load events
 */
$window.on('load', function() {
	
	// Image deferring
	$('img[data-src]').each(function() {
	
		var $img = $(this);
		
		$img.attr('src', $img.data('src'));
	
	});
	
	// Background images
	$('[data-bg]').each(function() {
	
		var $el = $(this);
		
		$el.css('background-image', 'url(' + $el.data('bg') + ')');
	
	});
	
	// Parallax
	$window.enllax();

});


/**
 * More article items
 */
$('body.guides-and-insights a.more-items').on('click', function(e) {
	
	e.preventDefault();
	
	var $this = $(this);
	
	var numToShow = parseInt($this.closest('div.category').data('num-to-show'));
						 
	var $articles = $this.closest('div.category').find('div.article');
	
	var unhidden = 0;
	
	// Make the next group visible
	$articles.each(function() {
	
		var $article = $(this);
		
		if ($article.is(':visible') === false) {
			
			$article.removeClass('inactive');
			$article.find('img').attr('src', $article.find('img').data('article-src'));
			
			unhidden ++;
			
			// Only do numToShow at a time
			if (unhidden == numToShow) {
				
				return false;
				
			}
			
		}
	
	});
	
	// Decide whether to hide the button
	var hasHidden = false;
	
	$articles.each(function() {
		
		var $article = $(this);
		
		if ($article.is(':visible') === false) {
			
			hasHidden = true;
			
			return false;
			
		}
		
	});
	
	if (hasHidden === false) {
		
		$this.remove();
		
	}
	
});


/**
 * Sticky messages
 */
var $stickyMessagesA = $('div.sticky.message a');

var timeout = setTimeout(function() {

	$stickyMessagesA.trigger('click');

}, 5000);

$stickyMessagesA.on('click', function(e) {
	
	e.preventDefault();
	
	$(this).closest('div.message').slideUp();
	
	clearTimeout(timeout);
	
});


/**
 * Truncate text with gradient and button
 */
$('div[data-truncate]').each(function() {

	var $div = $(this);
	
	if ($div.innerHeight() > 250) {
		
		$div.addClass('truncated')
		    .append('<div class="truncated-end ' + $div.data('truncate').escapeHTML() + '"></div><a class="button remove-truncation" href="#">Read more</a>');
		
	}

}).on('click', 'a.button.remove-truncation', function(e) {
	
	e.preventDefault();
	
	var $div = $(this).closest('div[data-truncate]');
	
	$div.removeClass('truncated')
	    .find('div.truncated-end, a.remove-truncation')
		.fadeOut();;
	
});;



/**
 * Make external links open in new window
 */
$('div.overlay a[href^="http://"], div.overlay a[href^="https://"]').attr('target','_blank');


/**
 * Bio link
 */
$('a.view-bio').on('click', function(e) {
	
	e.preventDefault();
	
	var $this = $(this);
	
	$this.toggleClass('active');
	
	$this.closest('div.member')
	     .find('div.bio')
		 .toggleClass('active');
	
});


/**
 * Validate email (it's local scope in texelwire.js so can't use that)
 */
function validateEmail(email) {
	
	var regex = /\S+@\S+\.\S+/;
	
	return regex.test(email);
		
}


/**
 * Scrolls to the top of the payment form for better UX
 */
function setPaymentScroll() {
	
	$htmlBody.animate({

		scrollTop: $('form.payment').offset().top - $header.outerHeight()

	}, 1000, 'easeInOutExpo');
	
}


/**
 * Payment error
 */
var $paymentError = $main.find('div.payment-error');

function paymentError(error) {
	
	$paymentError.text(error)
	             .addClass('active');
				 
	setPaymentScroll();
	
}

/**
 * Stripe config
 */
var stripeElementsConfig = {

	fonts: [

		{ cssSrc: 'https://fonts.googleapis.com/css?family=Lato:400,400i' }

	],
	locale: 'auto'

};

var stripeStyle = {

	base: {

		iconColor: '#1C1F2A',
		color: '#1C1F2A',
		fontFamily: 'Lato, sans-serif',
		fontSize: '18px',
		'::placeholder': {

			color: '#888888'

		},

	},
	invalid: {

		color: '#E94410',
		iconColor: '#E94410'

	}

};


/**
 * Set form field names
 */
twireStripe.cardBillingFormNames = {

	name: 	'billing-name',
	email:	'billing-email',
	phone: 	'billing-phone',
	address: {

		line1: 		'billing-address-line-1',
		line2: 		'billing-address-line-2',
		town: 		'billing-town',
		county: 	'billing-county',
		postcode: 	'billing-postcode',
		country:	'billing-country'

	}

}

/**
 * Date picker
 */
$('input.date-picker').datepicker({

	format: 	'dd/mm/yyyy',
	weekStart: 	1

});


/*
 * Payment validation
 */
$('body.payment').each(function() {

	var $form		= $(this).find('main form.payment');
	
	// Set up Stripe
	twireStripe.init($form, $main.data('stripe-pk'), $main.data('payment-intent-token'), stripeElementsConfig, stripeStyle);
	
	twireStripe.onGeneralError = function($form, message) {
		
		paymentError(message);

		$form.removeClass('disabled');

	}

	twireStripe.onServerError = function($form, message) {

		alert(message);

		$form.remove();

	}

	twireStripe.onSuccess = function($form, paymentIntentID, customData) {

		$form.closest('div.form')
		     .remove();

		var $summary = $main.find('div.summary');

		$summary.find('span.reference').text(customData.reference);
		$summary.find('span.deposit').text(customData.deposit);
		$summary.find('span.card-brand').text(customData.cardBrand);
		$summary.find('span.card-type').text(customData.cardType);
		$summary.find('span.card-exp').text(customData.cardExp);
		$summary.find('span.card-num').text(customData.cardNum);

		$summary.closest('div.confirmation')
		        .addClass('active');

		$main.find('div.steps div.step')
		     .addClass('done');

		setPaymentScroll();

	}

	twireStripe.onPaymentStart = function($form) {

		$paymentError.removeClass('active')
		             .text('');

		$form.addClass('disabled');

	}
	
	// The form works via AJAX so ignore this
	$form.on('submit', function(e) {

		e.preventDefault();

		// Check for errors
		if ($form.attr('data-error-alert') !== '') {

			alert($form.attr('data-error-alert'));

		} else {

			twireStripe.processPayment('/process-payment/', {});

		}
		
	});

	var elements = twireStripe.elements;	

	// Form and section validation
	$form.find(':input')
	     .on('change', function() {

		var $input		= $(this);
		var $steps 		= $main.find('div.steps div.step');

		// Go through current section and check for requireds and emails
		var formErrors 	= 0;
		var errorAlert 		= '';

		$form.find('*[data-required]')
		        .each(function() {

			var $el = $(this);

			if ($el.val() === '') {

				errorAlert += $el.data('required') + '\n';

				formErrors ++;

			}

		});

		$form.find('*[data-email]')
		        .each(function() {

			var $el = $(this);

			if (!validateEmail($el.val())) {

				errorAlert += $el.data('email') + '\n';

				formErrors ++;

			}

		});

		// Stripe

		var stripeEl = elements.getElement('cardNumber');

		var isInvalid = stripeEl._invalid;
		var isEmpty = stripeEl._empty;

		var isValid = !(isEmpty || isInvalid);

		if (isValid === false) {

			formErrors ++;

			errorAlert += 'Please enter a valid credit card number' + '\n';

		}

		stripeEl = elements.getElement('cardExpiry');

		var isInvalid = stripeEl._invalid;
		var isEmpty = stripeEl._empty;

		var isValid = !(isEmpty || isInvalid);

		if (isValid === false) {

			formErrors ++;

			errorAlert += 'Please enter a valid credit card expiry date' + '\n';

		}

		stripeEl = elements.getElement('cardCvc');

		var isInvalid = stripeEl._invalid;
		var isEmpty = stripeEl._empty;

		var isValid = !(isEmpty || isInvalid);

		if (isValid === false) {

			formErrors ++;

			errorAlert += 'Please enter a valid credit card CVC' + '\n';

		}

		// If errors add classes and icon
		if (formErrors > 0) {

			$form.find('section.stripe')
			     .removeClass('done');

		} else {

			// If success add icon
			$form.find('section.stripe')
			      .addClass('done');

		}

		$form.attr('data-error-alert', errorAlert);

	 });

	// Make Stripe changes trigger form change
	var cardNumber = elements.getElement('cardNumber');
	var cardExpiry = elements.getElement('cardExpiry');
	var cardCvc 	= elements.getElement('cardCvc');

	cardNumber.on('change', function(event) {

		$form.find(':input').trigger('change');

	});

	cardExpiry.on('change', function(event) {

		$form.find(':input').trigger('change');

	});

	cardCvc.on('change', function(event) {

		$form.find(':input').trigger('change');

	});

});


/*
 * Application validation
 */
$('body.application').each(function() {

	var $form		= $(this).find('main form.application');
	var currentStep = 1;
	var $nav 		= $form.find('nav');
	var $sections 	= $form.find('section');
	var $steps 		= $main.find('div.steps div.step');
	var numSteps 	= $steps.length;

	// Form and section validation
	$form.find(':input')
	     .on('change', function() {

		var $input		= $(this);
		var $parent 	= $form.closest('div.form');
		var $section 	= $input.closest('section[data-step]');

		// Go through current section and check for requireds and emails
		var sectionErrors 	= 0;
		var errorAlert 		= '';

		$section.find('*[data-required]')
		        .each(function() {

			var $el = $(this);

			if ($el.val() === '') {

				errorAlert += $el.data('required') + '\n';

				sectionErrors ++;

			}

		});

		$section.find('*[data-email]')
		        .each(function() {

			var $el = $(this);

			if (!validateEmail($el.val())) {

				errorAlert += $el.data('email') + '\n';

				sectionErrors ++;

			}

		});

		// If errors add classes and icon
		if (sectionErrors > 0) {

			$section.removeClass('done');

		} else {

			// If success add icon
			$section.addClass('done');

		}

		// Remove done classes from steps
		$steps.removeClass('done');

		// Add done classes to steps based on sections
		$sections.each(function() {

			var $section = $(this);

			if ($section.hasClass('done') === true && $section.data('step') < 5) {

				$steps.filter('.step-' + $section.data('step'))
				      .addClass('done');

			}

		});

		$form.attr('data-error-alert', errorAlert);

	 });

	// Button behaviour
	$nav.find('a.prev')
	    .on('click', function(e) {

		e.preventDefault();

		$sections.removeClass('active');

		currentStep --;

		$sections.filter('[data-step="' + parseInt(currentStep) + '"]')
		         .addClass('active');

		// Wipe errors as the form should be valid
		// This also prevents the “You haven’t started filling out this section yet” message refiring
		$form.attr('data-error-alert', '');

	});

	$nav.find('a.next')
	    .on('click', function(e) {

		e.preventDefault();

		// Check for errors
		if ($form.attr('data-error-alert') !== '') {

			alert($form.attr('data-error-alert'));

		} else {

			$sections.removeClass('active');

			currentStep ++;

			$sections.filter('[data-step="' + parseInt(currentStep) + '"]')
			         .addClass('active');

			// Without this users can go to the next section without doing 
			// anything since :input hasn't fired yet to run validation
			$form.attr('data-error-alert', 'You haven’t started filling out this section yet');

		}

	});

	$nav.find('a.prev, a.next')
	    .on('click', function() {

		// Buttons nav
		if (currentStep == 1) {

			$nav.find('a.prev')
			    .addClass('disabled');

			$nav.find('a.next')
			    .addClass('active');

			$nav.find('button')
			    .removeClass('active');

		} else if (currentStep == numSteps) {

			$nav.find('a.next')
			    .removeClass('active');

			$nav.find('a.prev')
			    .addClass('active')
				.removeClass('disabled');

			$nav.find('button')
			    .addClass('active');

		} else {

			$nav.find('a.next')
			    .addClass('active');

			$nav.find('a.prev')
			    .addClass('active')
				.removeClass('disabled');

			$nav.find('button')
			    .removeClass('active');

		}

		// Checkbox behaviour
		$form.find('section[data-step="5"] input[type="checkbox"]').on('change', function() {

			var $this = $(this);

			if ($this.is(':checked') === true) {

				$form.find('button[type="submit"]')
				     .removeClass('disabled');

			} else {

				$form.find('button[type="submit"]')
				     .addClass('disabled');

			}

		});

	});

});


/**
 * Google Places testimonials
 */
$.get('/json-testimonials', function(data) {

	var $template = $('template.testimonial');

	$main.find('div.google-testimonials')
	     .each(function() {

		var $this 		= $(this);
		var maxToShow	= $this.data('max-to-show');
		maxToShow 		= data.length < maxToShow ? data.length : maxToShow;

		for (var counter = 0; counter < maxToShow; counter ++) {

			$this.append($template.html());

			var $el = $this.find('div.testimonial')
			               .last();
						   
			$el.find('div.quote p')
			   .text(data[counter].text);

			$el.find('div.quote p')
			   .html($el.find('div.quote p').html().replace(/(\r\n|\n|\r)/g, '<br />'));

			$el.find('div.name')
			   .text(data[counter].author_name);

		}

	});

}).fail(function() {

    console.error('Error fetching Google Places data');

});


$window.trigger('scroll');
$window.trigger('resize');
